var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 20,
    rx: 4,
    stroke: "#74B743",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H9C10.6569 8 12 9.34315 12 11C12 12.6569 10.6569 14 9 14H1V8Z",
    stroke: "#74B743",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.868f3994e757d474b7f609a740c013af.svg";
export { ForwardRef as ReactComponent };